// extracted by mini-css-extract-plugin
export default {"layout":"Settings_layout__XvBjg","main":"Settings_main__LoE2t","main__container":"Settings_main__container__6BJkF","sidebar":"Settings_sidebar__oWFNO"};